window.$ && $(document).ready(function() {
    instagramGalleryMethod();
    switchTabButtonToGoods();
    imgNavTab();
    mediaGalleryMethod();
    mobilescroll();
    $('.instagram_product_handle').each(function() {
        var product_handle_str = $(this).attr('data');
        var product_info = getProductInfo(product_handle_str, $(this), getInstagramProductInfo);
    });
})
//window.money_format = '${{amount}}';
Shopify.formatMoney = function(cents, format) {
  var value = '',
  placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
  formatString = (format || this.money_format);

  if (typeof cents == 'string') {
    cents = cents.replace('.','');
  }

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

var slickDom = null;
function instagramGalleryMethod() { // 相册页面功能
  if($('.section-instagram-gallery').length <= 0) {
    return;
  }
  $(document).on('click', '.image-list-item', function() {
      let indexData = $(this).find('.img-box').attr('index');
      slickDom.slick('slickGoTo', Number(indexData)-1);
      const curDom = $('.image-list-slick-modal .image-list-item-video');
      for(let i = 0; i < curDom.length; i ++){
        curDom[i].addEventListener('pause', function() {
          $(curDom[i]).siblings('.video-icon').show();
        })
        curDom[i].addEventListener('play', function() {
          $(curDom[i]).siblings('.video-icon').hide();
          const curDom1 = $('.image-list-slick-modal .image-list-item-video');
          for(let i = 0; i < curDom1.length; i ++){
            const curClass =  $(curDom1[i]).parent().attr('class')
            if ($(curDom1[i]) && $(curDom1[i]).length > 0) {
             if (curClass.indexOf('slick-active') == 0){
                 $(curDom1[i])[0].pause()
             }
           }
          }
        })
        curDom[i].addEventListener('ended', function() {
          $(curDom[i]).siblings('.video-icon').show();
        })
      }
      setTimeout(function() {
        $('.image-list-slick-modal .video-icon').show();
      }, 800);
      $('body').addClass('cartover');
      $(".image-list-slick-modal").show();
  })
  $(document).on('click', '.slick-modal-mask-close', function() {
      $(".image-list-slick-modal").hide();
      $('body').removeClass('cartover');
      pauseVideo();
  })

  $('.image-list-slick-modal .slick-modal-mask-close').on('touchend', function(e) {
     $(".image-list-slick-modal").hide();
     $('body').removeClass('cartover');
     pauseVideo();
     e.preventDefault();
  })
  $(document).on('click', '.image-list-slick-modal .video-icon', function() {
    pauseVideo();
    const $domVideo = $(this).siblings('video');
    if ($domVideo && $domVideo.length > 0) {
      $domVideo[0].play();
      $(this).hide();
    }
  })
  $(document).on('click', '.section-instagram-gallery .next-slide', function(e) {
     pauseVideo();
     if (e && e.preventDefault){
         e.preventDefault();
     } else {
        window.event.returnValue = false;
     }
     if(e && e.stopPropagation){
        e.stopPropagation()
     }
     return false;
  })
  $(document).on('click', '.section-instagram-gallery .prev-slide', function(e) {
     pauseVideo();
     if (e && e.preventDefault){
         e.preventDefault();
     } else {
        window.event.returnValue = false;
     }
     if (e && e.stopPropagation){
       e.stopPropagation()
     }
     return false;
  })
  function pauseVideo() {
    const curDom = $('.image-list-slick-modal .image-list-item-video');
    for(let i = 0; i < curDom.length; i ++){
     if ($(curDom[i]) && $(curDom[i]).length > 0) {
       $(curDom[i])[0].pause()
     }
    }
  }
  slickDom =  $('.image-list-slick-modal .image-list-slick').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: isAppleMobile() ?  false : true, 
    infinite: true,
    vertical: false,
    verticalSwiping: false,
    centerMode: false,
    centerPadding: 0,
    //prevArrow:'<span class="prev-slide"><i class="fa fa-angle-left"></i></span>',
    //nextArrow:'<span class="next-slide"><i class="fa fa-angle-right"></i></span>',
    prevArrow:'<span class="prev-slide"><svg fill="none" width="16" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></span>',
    nextArrow:'<span class="next-slide"><svg fill="none" width="16" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></span>',
    focusOnSelect: false,
    swipe: isAppleMobile() ?  false : true,
    //lazyLoad:'ondemand'
  })

  $('.js_section_instagram_gallery .image-list').slick({
    slidesToShow:  $(window).width() > 990 ? 4.03 : 1.03,
    slidesToScroll: $(window).width() > 990 ? 4 : 1,
    dots: false,
    arrows: true,
    infinite: true,
    vertical: false,
    verticalSwiping: false,
    centerMode: false,
    centerPadding: 0,
    prevArrow:'<button type="button" class="prev-slide"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    nextArrow:'<button type="button" class="next-slide"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    //prevArrow:'<button type="button" class="prev-slide"><svg fill="none" width="23" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></button>',
    //nextArrow:'<button type="button" class="next-slide"><svg fill="none" width="23" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></i></button>',
    focusOnSelect: false,
    //lazyLoad:'ondemand',
 })
 $('.js_section_instagram_gallery_index .image-list').slick({
    slidesToShow:  $(window).width() > 990 ? 1.01 : 1.03,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    infinite: true,
    vertical: false,
    verticalSwiping: false,
    centerMode: true,
    centerPadding: $(window).width() > 990 ? 0 : '0px',
    //prevArrow:'<button type="button" class="prev-slide"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    //nextArrow:'<button type="button" class="next-slide"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    prevArrow:'<button type="button" class="prev-slide"><svg fill="none" width="23" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></button>',
    nextArrow:'<button type="button" class="next-slide"><svg fill="none" width="23" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></i></button>',
    focusOnSelect: false,
    initialSlide: 1,
    adaptiveHeight: false
    //lazyLoad:'ondemand',
 })
 slickDom.on("afterChange", function(e, slick, currentSlide){
   if (e && e.preventDefault){
       e.preventDefault();
   } else {
      window.event.returnValue = false;
   }
   if (e && e.stopPropagation){
     e.stopPropagation()
   }
 })
  // const height1 = $('.image-list-item').width();
  // $(".image-list-item .img-box img").css('height', height1+'px');
  // $(".image-list").css('opacity', 1);
  const height1 = $('.image-list-item').width() ? $('.image-list-item').width() : $(window).width()/2
  const isHaveClassDom = $('.section-instagram-gallery .js_section_instagram_gallery_index');
  if (isHaveClassDom.length > 0) {
     $(".image-list-item .img-box img").css('height', (height1/2)+'px');
    const isPc = $(window).width() > 990 ? true : false;
     const imageDom = $(".image-list-item-outer");
     for(let i=0; i <imageDom.length; i ++) {
        const firstDom = $(imageDom[i]).children().eq(0); //第一个元素
        if (isPc){
          firstDom.find('.img-box img').css('height', (height1+20)+'px');
        } else {
          firstDom.find('.img-box img').css('height', (height1+10)+'px');
        }
    }
  } else {
    $(".image-list-item .img-box img").css('height', height1+'px');
  }
  $(".image-list").css('opacity', 1);
}

// 是否为 iPhone
function isAppleMobile() {
  return (navigator.platform.indexOf('iPhone') != -1);
}
function jdgmCarouselArrow() {
  const container =  $('.jdgm-container .jdgm-carousel__arrows');
  const leftArrow = container.find('.jdgm-carousel__left-arrow');
  const rightArrow = container.find('.jdgm-carousel__right-arrow');
  const arrowDom1 = container.find('.jdgm-carousel__left-arrow .fa-arrow-left');
  const arrowDom2 = container.find('.jdgm-carousel__right-arrow .fa-arrow-right');
  arrowDom1.length==0 && leftArrow.append(`<svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg>`)
  arrowDom2.length==0 &&  rightArrow.append(`<svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg>`)
}
function getProductnstagram(section_filename,ele_obj,data){
  console.log('data', data);
  var section_filename_list = section_filename.split('&');
  if(section_filename_list.length >=1){
    var section_filename_arr = section_filename_list[0].split(',');
    
    let current_product_sku_ele = $('#product_spu_title');
    if(current_product_sku_ele.length){
      for(var i=0; i<section_filename_arr.length; i++){
        if((typeof data[section_filename_arr[i]]) != 'undefined' && data[section_filename_arr[i]]){
          var product_handle_contain = 0;
          let $res_html = $(data[section_filename_arr[i]]);
          $res_html.find('.instagram_product_handle').each(function() {
            var product_handle_str = $(this).attr('product_handle');
            if(product_handle_str != ''){
              if(current_product_sku_ele.attr('product_handle') != product_handle_str){
                $res_html.find($(this)).remove();
              }else{
                product_handle_contain = 1;
              }
            }
          });
          if(product_handle_contain){
            console.log('---');
            console.log($res_html.html());
            ele_obj.before($res_html);
            if($('.instagram_product_handle').length>0){
              $('.engoj_find_img_div.instagram_product_handle').each(function() {
                var product_handle_str = $(this).attr('data');
                var product_info = getProductInfo(product_handle_str, $(this), getInstagramProductInfo);
              });
              //$('.section-instagram-gallery .instagram_gallery_title').html('Find #Sedeta In Media');
              instagramGalleryMethod();
            }
          }
        }
      }
    }
  }
}
function ajaxGetSections(section_filename,ele_obj,callback){
    if (section_filename && ele_obj && callback) {
      $.ajax({
          url: '/?sections='+section_filename,
          type: 'GET',
          dataType: "json",
          cache: false,
          success: function(data) {
            callback(section_filename,ele_obj, data);
          },
          error: function(data) {
            console.log('section', data);
          }
      });
    }
  }
function getProductInfo(product_handle, ele_obj, callback) {
  if (product_handle) {
      try{
        jQuery.ajax({
            dataType: "json",
            url: "/products/" + $.trim(product_handle) + ".js",
            cache: false,
            success: function(data) {
                callback && callback(ele_obj, data);
            },
            error: function() {

            }
        });
      } catch (e) {
       console.log(e);
      }
    }
}

function getInstagramProductInfo(ele_obj, product_info){
    if(ele_obj && ele_obj.length && product_info && (typeof product_info.featured_image) != 'undefined' && product_info.featured_image){
        $(ele_obj).find('a').attr('href', product_info.url).attr('title',product_info.title);
        $(ele_obj).find('img.img-responsive').attr('src',product_info.featured_image+'&width=200').attr('title',product_info.title).attr('alt',product_info.featured_image.alt);
        if(product_info.compare_at_price == null){
            $(ele_obj).find('span.price').html(Shopify.formatMoney(product_info.price, window.money_format));
        }else{
            $(ele_obj).find('span.price').html(Shopify.formatMoney(product_info.price, window.money_format));
            $(ele_obj).find('s.price-old').html(Shopify.formatMoney(product_info.compare_at_price, window.money_format));
        }
    }
}
function ajaxAddCartByForm(form_selector){
    $(form_selector).on('submit', function(event) {
      event.preventDefault(); // prevent default form submission
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $(this).serialize(),
        dataType: 'json',
        success: function(line_item) {
          console.log(12, line_item);
          let mycart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          if((typeof line_item) != 'undefined'){
            mycart.renderContents(line_item);
            if (mycart && mycart.classList.contains('is-empty')) mycart.classList.remove('is-empty');
          }
        },
        error: function(data) {
          console.log(22, data);
        }
      });
    });
}
function copyMethod (spu_no) {
    try {
         const newInput = document.createElement("input");
         newInput.value = spu_no;
         document.body.appendChild(newInput);
         newInput.select();
         document.execCommand("Copy");
         newInput.remove();
         showCustomModal();
     } catch (e) {
       console.log(e);
     }
}
function showCustomModal() {
    setTimeout(function () {
        hideCustomModal();
    }, 2000);
}
function hideCustomModal() {
   $('.ant-message').css('display', 'none');
   $('.coupon-copy-btn').text('Copy');
}


function menuScrollMethod(navLi) {
  //const isHave = $('.section-float-nav-new .row ').hasClass('section-float-nav-mobile-new');
  //const navLi = isHave ? $('.section-float-nav-new .row .section-float-nav-ul li') : $('.section-float-nav .row .section-float-nav-ul li');
  let arr = [];
  for (let i = 0; i < navLi.length; i ++) {
    const idName =  $(navLi[i]).find('a').attr('href');
    const heightData = $(idName).length > 0 && movingDistance($(idName));
    arr.push({
      id: idName,
      left: $(navLi[i]).length > 0 ? parseInt($(navLi[i])[0].getBoundingClientRect().left) : 0,
      range: heightData ? heightData.positionRange : [0, 0],
      top: heightData ? heightData.top : 0
    })
    if ($(window).width() > 990) {
      $(idName).on('mouseenter', function() {
         const curTop = parseInt($(idName)[0].getBoundingClientRect().top)
         const haveData = arr.filter(v => v.id == idName);
         const indexN = arr.findIndex(v => v.id == idName);
         const topValue1 = haveData.length > 0 ?  parseInt(haveData[0].top) : 0;
         if (topValue1 == curTop) { // 当前页面是否在滚动
           return
         }
         if (indexN > -1) {
            arr[indexN].top = curTop
         }
         const str = 'a[href="'+idName+'"]';
         const dom = navLi.find(str).parent();
         const curIndex = dom.index();
         dom.addClass('li-active').siblings().removeClass('li-active');
         if (curIndex > 4 || curIndex < 3){
           curIndex > 4  && $('.section-float-nav .section-float-nav-ul .next-slide').click();
           curIndex < 3 && $('.section-float-nav .section-float-nav-ul .prev-slide').click();
         }
      })
    } else {
      $(document).on('touchstart', idName, function() {
         const str = 'a[href="'+idName+'"]';
         const dom = navLi.find(str).parent();
         const curIndex = dom.index();
         const checkChildDom = dom.length > 0 ? dom[0].getBoundingClientRect().left : 0;
         dom.addClass('li-active').siblings().removeClass('li-active');
         let scrollWidth = parseInt(document.querySelector('.row .section-float-nav-ul').scrollLeft) ; // 滚动的宽度+元素与窗口的距离
         debounce(moveToNavItem('.row .section-float-nav-ul', checkChildDom+scrollWidth+20), 5);
         //const haveData = arr.filter(v => v.id == idName);
         //const leftValue1 = haveData.length > 0 ? haveData[0].left : checkChildDom;
         //moveToNavItem('.row .section-float-nav-ul', checkChildDom ? checkChildDom.left : 0 )
      })
      if ($("#bundle-product-view-id").length == 0) {
        $(navLi[i]).find('a[href="#bundle-product-view-id"]').parent().hide()
      }
    }
  }
}

function movingDistance($dom) {
  if ($dom && $dom.length == 0) { return };
  let idNameDom =  $dom.length > 0 ? $dom[0].getBoundingClientRect() : null;
  let idNameDomTop = idNameDom ? parseInt(idNameDom.top) : 0 ;
  let idNameDomLeft = idNameDom ? parseInt(idNameDom.left) : 0 ;
  let idNameDomBottom = idNameDom ? parseInt(idNameDom.bottom) : 0 ;
  let idNameDomHeight = idNameDom ? parseInt(idNameDom.height) : 0 ;
  let scrollHeigth = parseInt(document.documentElement.scrollTop) ||  parseInt(window.scrollY) ; // 滚动的高度+元素与窗口的距离
  let idNameRange = [idNameDomTop+scrollHeigth, idNameDomTop+idNameDomHeight+scrollHeigth]; // 元素位置所处的范围
  return {
    top: idNameDomTop, // 离body的距离
    height: idNameDomHeight, // 元素的高度
    scrollHeigth: scrollHeigth, // 滚动的高度
    positionRange: idNameRange,  // 元素位置的范围
    left: idNameDomLeft, 
    bottom: idNameDomBottom
  }
}

function moveToNavItem(className, leftValue=0, top=0) {
  document.querySelector(className).scrollTo({
    top: top,
    left: leftValue ,
    behavior: "smooth",
  })
}

function debounce(fn, delay) { // 节流函数，频繁操作只执行一次
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}
function switchTabButtonToGoods() { // 切换按钮到对应的商品菜单
   setTimeout(function(){ 
    $('.section-float-nav .row .section-float-nav-ul li').length > 0 && menuScrollMethod($('.section-float-nav .row .section-float-nav-ul li'));
    $('.section-float-nav-new .row .section-float-nav-ul li').length > 0 && menuScrollMethod($('.section-float-nav-new .row .section-float-nav-ul li'));
    if ($('.section-float-nav-new-v2 .row .section-float-nav-ul li').length > 0) {
      menuScrollMethod($('.section-float-nav-new-v2 .section-float-nav-ul li'));
      $('.section-float-nav-new-v2 .container-v2').css('visibility', 'visible');
      //const isHidden = $('.menu_moblie .header_top_bar_block').is(':hidden');
      //$(window).width() < 990 && $(".section-float-nav-new-v2").css('top', isHidden ? '53px' : '97px');
    }
  }, 500) 
   $(document).on('click', '.row .section-float-nav-ul li', function(e) {
     const curIndex = $(this).index();
     const idName = $(this).find('a').attr('href');
     const heightData = $(idName).length > 0 && movingDistance($(idName));
     const parentsClass = $(this).parents('div[data-section-type]').attr('data-section-type');
     $(this).addClass('li-active').siblings().removeClass('li-active');
     let scollHeight = 75
     if ($(window).width() < 990) { // M端
       const navDom = $('.mobile-model-nav .section-float-nav-ul li');
       navDom.removeClass('li-active');
       navDom.eq(curIndex).addClass('li-active');
       scollHeight = 97
     } else { // pc
       scollHeight = 20
     }
     const mobileDom = $('.mobile-model-nav');
     const isHiden = mobileDom.is(":hidden");
     if (!isHiden) {
      mobileDom.hide();
      $(this).removeClass('up-style').addClass('down-style');
     }
     let fixBarHeight = 75
     if (parentsClass == 'section-float-nav-new') {
      fixBarHeight = parseInt($('.section-float-nav-new').height())+90 
     } else if (parentsClass == 'section-float-nav-new-v2') {
      fixBarHeight = parseInt($('.section-float-nav-new-v2').height())+scollHeight
     } else if (parentsClass == 'section-float-nav') {
      fixBarHeight = parseInt($('.section-float-nav').height())+75
     }
     //const isHave = $('.section-float-nav-new .row ').hasClass('section-float-nav-mobile-new');
     //const fixBarHeight = isHave ? parseInt($('.section-float-nav-new').height())+90 : parseInt($('.section-float-nav').height())+75;
     $(idName).css('scroll-margin-top', fixBarHeight+'px');
     e.preventDefault();
     const curScrollTop = heightData ? heightData.scrollHeigth : 0;
     const idNameDomTop = heightData ? heightData.top : 0;
     document.documentElement.scrollTop = parseInt(idNameDomTop+curScrollTop-fixBarHeight);
  })

  $(document).on('click', '.mobile-model-nav .section-float-nav-ul li', function(e) { // m端下拉点击菜单
     if ($(window).width() < 990) {
      const curIndex = $(this).index();
      const liDom = $('.row .section-float-nav-ul li');
      const idName = $(this).find('a').attr('href');
      const heightData = $(idName).length > 0 && movingDistance($(idName));
      const parentsClass = $(this).parents('div[data-section-type]').attr('data-section-type');
      $(this).addClass('li-active').siblings().removeClass('li-active');
      liDom.removeClass('li-active');
      liDom.eq(curIndex).addClass('li-active');
      $('.mobile-model-nav').hide();
      $('.row .mobile-down-btn').removeClass('up-style').addClass('down-style');
      const childDom = document.querySelector('.row .section-float-nav-ul').children;
      const checkChildDom = childDom.length > 0 ? childDom[curIndex].getBoundingClientRect() : null;
      const scrollWidth = parseInt(document.querySelector('.row .section-float-nav-ul').scrollLeft) ; // 滚动的高度+元素与窗口的距离
      const leftWidth = checkChildDom ? checkChildDom.left : 0 ;
      moveToNavItem('.row .section-float-nav-ul', scrollWidth+leftWidth ); // 菜单滚动条
      let fixBarHeight = 75
      if (parentsClass == 'section-float-nav-new') {
        fixBarHeight = parseInt($('.section-float-nav-new').height())+90 
      } else if(parentsClass == 'section-float-nav-new-v2') {
        fixBarHeight = parseInt($('.section-float-nav-new-v2').height())+100
      } else if(parentsClass == 'section-float-nav') {
        fixBarHeight = parseInt($('.section-float-nav').height())+75
      }
      //const fixBarHeight = parseInt($('.section-float-nav').height())+75;
      $(idName).css('scroll-margin-top', fixBarHeight+'px');
      e.preventDefault();
      const curScrollTop = heightData ? heightData.scrollHeigth : 0;
      const idNameDomTop = heightData ? heightData.top : 0;
      document.documentElement.scrollTop = parseInt(idNameDomTop+curScrollTop-fixBarHeight);
    }
  })
  
  $(document).on('click', '.row .mobile-down-btn', function(e) {
    const isHiden = $('.mobile-model-nav').is(":hidden");
    const mobileDom = $('.mobile-model-nav');
    if (isHiden) {
      mobileDom.show();
      $(this).removeClass('down-style').addClass('up-style');
    } else {
      mobileDom.hide();
      $(this).removeClass('up-style').addClass('down-style');
    }
  })
  if ($(window).width() > 990) {
    $('.section-float-nav .section-float-nav-ul').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows:  true,
      infinite: false,
      vertical: false,
      verticalSwiping: true,
      prevArrow:'<button type="button" class="prev-slide" aria-label="prev"><svg fill="none" width="23" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></button>',
      nextArrow:'<button type="button" class="next-slide" aria-label="next"><svg fill="none" width="23" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-width="2px" stroke-linecap="square"></path></svg></i></button>',
      focusOnSelect: true,
    })
  }
}

function slickObject(dom, pcNum=1, mobileNum=1, optionField= {}  ) {
  dom.slick({
    slidesToShow: $(window).width() > 990 ? pcNum : mobileNum,
    slidesToScroll: 1,
    dots: false,
    arrows:  true,
    infinite: true,
    vertical: false,
    verticalSwiping: false,
    centerMode: $(window).width() > 990 ? false : true,
    centerPadding: $(window).width() > 990 ? '0px' : '3px',
    prevArrow:'<button type="button" class="prev-slide" aria-label="prev"><svg fill="none" width="15" class="fa-angle-left" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="#fff" stroke-width="2px" stroke-linecap="square"></path></svg></button>',
    nextArrow:'<button type="button" class="next-slide" aria-label="next"><svg fill="none" width="15" class="icon fa-angle-left" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="#fff" stroke-width="2px" stroke-linecap="square"></path></svg></i></button>',
    focusOnSelect: false,
    ...optionField
  })
  return dom
}

function imgNavTab() {
  const option ={
    arrows: false,
    infinite: false,
    centerPadding: $(window).width() > 990 ? '0px' : '0px',
  }
  const slickDom = slickObject($('.img-nav-tab-section .img-nav-tab-content'), 1, 1, option)
  $('.img-nav-tab-section .img-nav-tab-content').css('opacity', 1)
  $(document).on('click', '.img-nav-tab-section .img-nav-tab-menu li', function(e) {
    const num =  $(this).index()
    $(this).addClass('nav-li-active').siblings().removeClass('nav-li-active')
    slickDom.slick('slickGoTo', Number(num));
  })
  slickDom.on("afterChange", function(e, slick, currentSlide){
    $('.img-nav-tab-section .img-nav-tab-menu li').eq(currentSlide).addClass('nav-li-active').siblings().removeClass('nav-li-active')
  })
}

function mediaGalleryMethod() {
  const option ={
    arrows: $(window).width() > 990 ? true : false,
    infinite: false,
    dots: true,
    touchMove:$(window).width() > 990 ? false : true,
    centerPadding: $(window).width() > 990 ? '0px' : '0px',
    prevArrow:'<button type="button" class="prev-slide" aria-label="prev"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    nextArrow:'<button type="button" class="next-slide" aria-label="next"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
  }
  const option1 = {
    arrows: true,
    infinite: false,
    dots: $(window).width() > 990 ? false : true,
    centerPadding: $(window).width() > 990 ? '0px' : '0px',
    prevArrow:'<button type="button" class="prev-slide" aria-label="prev"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    nextArrow:'<button type="button" class="next-slide" aria-label="next"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>'
  }
  const option3 ={
    arrows: true,
    infinite: false,
    dots: $(window).width() > 990 ? false : true,
    centerPadding: $(window).width() > 990 ? '0px' : '0px',
    prevArrow:'<button type="button" class="prev-slide" aria-label="prev"><svg width="16" height="16" class="fa-arrow-left" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
    nextArrow:'<button type="button" class="next-slide" aria-label="next"><svg width="16" height="16" class="fa-arrow-right" viewBox="0 0 10 17"  xmlns="http://www.w3.org/2000/svg"><path d="M0.0802641 5.1485L0.526264 5.5885C0.577331 5.63877 0.646111 5.66694 0.717764 5.66694C0.789416 5.66694 0.858196 5.63877 0.909264 5.5885L4.40926 2.1385L4.40926 16.7325C4.40979 16.8035 4.43837 16.8714 4.48876 16.9214C4.53915 16.9714 4.60727 16.9995 4.67826 16.9995H5.30926C5.34459 16.9998 5.37962 16.9931 5.41236 16.9798C5.4451 16.9665 5.4749 16.9469 5.50006 16.9221C5.52523 16.8973 5.54526 16.8678 5.55902 16.8353C5.57278 16.8028 5.58 16.7678 5.58026 16.7325L5.58026 2.1385L9.08026 5.5885C9.13133 5.63877 9.20011 5.66694 9.27176 5.66694C9.34342 5.66694 9.4122 5.63877 9.46326 5.5885L9.90926 5.1485C9.93433 5.12393 9.95424 5.0946 9.96783 5.06223C9.98143 5.02986 9.98843 4.99511 9.98843 4.96C9.98843 4.9249 9.98143 4.89015 9.96783 4.85778C9.95424 4.82541 9.93433 4.79608 9.90926 4.7715L5.18526 0.113504C5.1342 0.063242 5.06542 0.0350723 4.99376 0.0350723C4.92211 0.0350723 4.85333 0.063242 4.80226 0.113504L0.0802641 4.7715C0.0551984 4.79608 0.0352865 4.82541 0.0216932 4.85778C0.00809999 4.89015 0.00109863 4.9249 0.00109863 4.96C0.00109863 4.99511 0.00809999 5.02986 0.0216932 5.06223C0.0352865 5.0946 0.0551984 5.12393 0.0802641 5.1485Z"></path></svg></button>',
  }
  const slickDom1 = slickObject($('.slide-products .js-slide-product'), 4, 1, option)
  const slickDom = slickObject($('.media-gallery .js-media-gallery'), 4, 1, option3)
  $('.slide-products .js-slide-product').css('opacity', 1)
  $(window).width()< 990 && slickObject($('.media-gallery-v2 .js-media-gallery-v2'), 1, 1, option1)
}

function mobilescroll() {
  const barHeight = $('div[id*=marquee_text_hfzJFj]').height(); //通知栏
  const headerHeight = $('.section-header').height(); // header
  const imgHeight = $('div[id*=hero_slideshow_]').height() || 0; //banner图
  const mHeight = $(window).width() < 990 ? 110 : 150;
  const isHave = $('.section-float-nav-new .row ').hasClass('section-float-nav-mobile-new'); // float-nav-new组件
  const curHeight = isHave ? parseInt($('#overview-product-view-id').height()) - 100 : parseInt(imgHeight) - mHeight;
  const $nav = parseInt(barHeight) + parseInt(headerHeight);
  scrollNavMethod(curHeight, $nav, $(this));
  let lastScrollTop = 0;
  $(document).scroll(function() {
    const currentScrollTop = $(this).scrollTop();
    // if ($(window).width() < 990) {
    //   if (currentScrollTop > lastScrollTop) {
    //     $('.section-float-nav-new-v2').css('top', '22px');
    //   } else if (currentScrollTop < lastScrollTop) {
    //     $('.section-float-nav-new-v2').css('top', '0px');
    //   }
    // }
    lastScrollTop = currentScrollTop;
    scrollNavMethod(curHeight, $nav, $(this))
  });
}

function scrollNavMethod(curHeight, navHeight, dom) {
    console.log('curHeight:'+curHeight+'navHeight:'+navHeight)
    if($(window).width() < 990) { // 移动端菜单设置
    const isHideBar = window.localStorage.getItem('hideHeaderBar');
    if (dom.scrollTop() > navHeight) { //滚动值大于主菜单栏
      //const heightData = isHideBar == 1 ? '53px' : '97px';
        $('.shopify-section.section-float-nav, .shopify-section.section-float-nav-new').css('top', '0px');
    } else {
        $('.shopify-section.section-float-nav, .shopify-section.section-float-nav-new').css('top', '38px');
    }

    if (parseInt(dom.scrollTop()) > parseInt(curHeight)) {
      $('.shopify-section.section-float-nav .container-v2, .shopify-section.section-float-nav-new .container-v2').css('visibility', 'visible');
      isHideBar == 1 ?  $("div[id*='countdown_inzatB']").addClass('floatNavBottom') : $("div[id*='countdown_inzatB']").addClass('floatNavBottom floatNavBottom1')
    }else{
        $('.shopify-section.section-float-nav .container-v2, .shopify-section.section-float-nav-new .container-v2').css('visibility', 'hidden');
      $("div[id*='countdown_inzatB']").removeClass('floatNavBottom floatNavBottom1');
    }
  } else {
    if (parseInt(dom.scrollTop()) > parseInt(curHeight)) {
      $('.shopify-section.section-float-nav, .shopify-section.section-float-nav-new').css('z-index', '3');
      $('.shopify-section.section-float-nav .container-v2, .shopify-section.section-float-nav-new  .container-v2').css('visibility', 'visible');
      $('.shopify-section.section-float-nav, .shopify-section.section-float-nav-new').css('top', '38px');
    }else{
      $('.shopify-section.section-float-nav .container-v2, .shopify-section.section-float-nav-new  .container-v2').css('visibility', 'hidden');
      $('.shopify-section.section-float-nav, .shopify-section.section-float-nav-new').css('z-index', '-1');
    }
  }
}